import { createApp } from 'vue';
import App from './App.vue';
import store from './store'; // Import your store
import axios from 'axios';
import router from './router';
import 'intersection-observer';
import '@fortawesome/fontawesome-free/css/all.css';


// Set the base URL for all Axios requests
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.withCredentials = true;

axios.get(axios.defaults.baseURL+'/api/csrf-token')
  .then(response => {
    const csrfToken = response.data.csrfToken;
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
  })
  .catch(error => {
    console.error('Error fetching CSRF token:', error);
  });

  axios.interceptors.request.use(
    (config) => {
      const token = sessionStorage.getItem('token');
      
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        let sessionId = sessionStorage.getItem('session_id');
        if(!sessionId) {
          sessionId = crypto.randomUUID();
          sessionStorage.setItem('session_id', sessionId);
        }
        config.headers['Session-Id'] = sessionId;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

createApp(App).use(router).use(store).mount('#app');